import { Grid } from "@mui/material"

import { LinearLoading } from 'common'

export const InfoVehicleReception = ({ useFetchInit }) => {
    const { FetchData } = useFetchInit
    const { fetchInfoForVehicleReception } = FetchData
    const { dataInfoVehicleReception, loadingFetchInfoVehicleReception } = fetchInfoForVehicleReception
    return (
        <>
            {(loadingFetchInfoVehicleReception) && (<LinearLoading />)}
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ marginBottom: 2, marginTop: 2 }}>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                        <span style={{ fontSize: '1.1rem' }}>
                            <strong>IDENTIFICADOR:</strong> {dataInfoVehicleReception[0]?.identificador || '' }
                        </span>
                        <span style={{ fontSize: '1.1rem' }}>
                            <strong>AUTORIDAD:</strong> {dataInfoVehicleReception[0]?.nombre_autoridad || '' }
                        </span>
                        <span style={{ fontSize: '1.1rem' }}>
                            <strong>FECHA INGRESO:</strong> {dataInfoVehicleReception[0]?.info_fecha_ingreso || '' }
                        </span>
                        <span style={{ fontSize: '1.1rem' }}>
                            <strong>TARIFA APLICADA:</strong> {dataInfoVehicleReception[0]?.tarifa_aplicada || '' } - Q {parseFloat(dataInfoVehicleReception[0]?.tarifa_monto).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '' }
                        </span>
                        <span style={{ fontSize: '1.1rem' }}>
                            <strong>DIAS TRANSCURRIDOS:</strong> {dataInfoVehicleReception[0]?.dias_transcurridos || '' }
                        </span>
                        <span style={{ fontSize: '1.1rem' }}>
                            <strong>TOTAL POR DIAS:</strong> Q {parseFloat(dataInfoVehicleReception[0]?.total_por_dias).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '' }
                        </span>
                        <span style={{ fontSize: '1.1rem' }}>
                            <strong>MOTIVO DE INGRESO:</strong> {dataInfoVehicleReception[0]?.info_motivo_recepcion || '' }
                        </span>
                        <span style={{ fontSize: '1.1rem' }}>
                            <strong>DEJO LLAVES:</strong> {dataInfoVehicleReception[0]?.info_tiene_llaves || '' }
                        </span>
                    </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                        <span style={{ fontSize: '1.1rem' }}>
                            <strong>GASTOS EXTRAS:</strong> Q {parseFloat(dataInfoVehicleReception[0]?.other_expense_total).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '' }
                        </span>
                        <span style={{ fontSize: '1.1rem' }}>
                            <strong>TOTAL DESCUENTOS:</strong> Q {parseFloat(dataInfoVehicleReception[0]?.info_descuento).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '' }
                        </span>
                        <span style={{ fontSize: '1.1rem' }}>
                            <strong>TOTAL A PAGAR:</strong> Q {parseFloat(dataInfoVehicleReception[0]?.total_pagar).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '' }
                        </span>
                        <span style={{ fontSize: '1.1rem' }}>
                            <strong>TOTAL RECIBIDO:</strong> Q {parseFloat(dataInfoVehicleReception[0]?.total_recibido).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '' }
                        </span>
                        <span style={{ fontSize: '1.1rem' }}>
                            <strong>SALDO:</strong> Q {parseFloat(dataInfoVehicleReception[0]?.saldo_total).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '' }
                        </span>
                    </div>
                </Grid>
            </Grid>
        </>
    )
}
